export enum LandingPopupKind{
    SITE_REG = 0,
    DESKTOP_REG = 1,
    DOUBLE_UNITY_MAIN_REG = 2,
    DOUBLE_SITE_MAIN_REG = 3,
    FOUR_STEP_SITE_REG = 4,
    FB_EMAIL_SITE_REG = 5,
    NICKNAME_SITE_REG = 6,
    TWO_STEP_SITE_REG = 7,
    MOBILE_EMAIL = 8
}
